// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'D:/jiugexuqiu/教育后台管理系统/node_modules/.pnpm/@umijs+renderer-react@4.5.3_ea331d0589dc8c9b1879a3919ebd4dcd/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
